import React, { useEffect, useState } from "react";
import './scoreCard.scss'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  CreateButton,
  GreyBackgroundButton,
  GreyBorderButton,
  RedBackgroundButton,
} from "../../../../Global/GlobalButton";
import {
  CheckLabel,
  InputLabel,
  InputType,
  SelectBorder,
} from "../../../../Global/GlobalFormElement";
import { MultiSelect } from "react-multi-select-component";
import {  RedMainHeading } from "../../../../Global/GlobalText";
import axios from "axios";
import { EXCHNAGE_URL } from "../../../../../Url/Url";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import FormCanvas from './EntryFormChild/FormCanvas';
import EditFieldModal from './EntryFormChild/EditFieldModal';
import FormulaValidationField from "./FormulaValidationField";
import ScoreCardData from "./ScoreCardData";
import { FaInfoCircle } from "react-icons/fa";

const CreateScoreCard = ({totalScorecards}) => {

  
  const [selected, setSelected] = useState([]);
  const [categories, setCategories]= useState([])
  const [loader, setLoader] = useState(false)
  
  const navigate = useNavigate();
      const location = useLocation();
      const { rId } = location.state || {}; 
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fields, setFields] = useState([]); // Your fields state
  const [selectedCategoryId, setSelectedCategoryId] = useState(""); 
  const [currentField, setCurrentField] = useState(null);
  const [generatedSchema, setGeneratedSchema] = useState(null);
  const [isValid, setIsValid] = useState(true);
    const [formula, setFormula] = useState('');
  
  const [titleValue, setTitleValue] = useState(""); 
  const [descriptionValue, setDescriptionValue] = useState(""); 
  const [numFields, setNumFields] = useState(fields.length);
  const [formValues, SetFormValues] = useState({
    category:""
  })

  const [scoreCardValue, setScoreCardValue] = useState("")
const [showTooltip, setShowTooltip] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCategoryNames, setSelectedCategoryNames] = useState([]); 


  useEffect(() => {
    setNumFields(fields.length);
  }, [fields]);


  
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("newest");
  const eventIdGet = useSelector((state) => state?.users?.id);
  const initialEventId = String(eventIdGet);
  const eventId = initialEventId;
  const { roundId } = useParams();

  const [criteriaList, setCriteriaList] = useState([
    { id: 1, value: '' }
  ]);
  const openModal = (field) => {
    setCurrentField(field); 
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false); 
    setCurrentField(null); 
  };
  
  const validateFormula = (formula, fieldsCount) => {
    const tokens = formula.match(/(\{[0-9]+\}|[+\-*/()])/g);
    
    if (!tokens) return false; 
  
    let openParentheses = 0;
    let lastToken = null;
  
    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];
  
      if (token.match(/\{[0-9]+\}/)) {
        const placeholderIndex = parseInt(token.slice(1, -1), 10);
        if (placeholderIndex < 1 || placeholderIndex > fieldsCount) {
          return false; 
        }
      } 
      else if (token === '(') {
        openParentheses++;
      } 
      else if (token === ')') {
        openParentheses--;
        if (openParentheses < 0) return false; 
      } 
      else if (['+', '-', '*', '/'].includes(token)) {
        if (!lastToken || ['+', '-', '*', '/'].includes(lastToken) || lastToken === '(') {
          return false; 
        }
      } else {
        return false; 
      }
  
      lastToken = token;
    }
    if (openParentheses !== 0) return false;

    if (lastToken === ')' || lastToken === '(') {
      return false;
    }
  
    return true; 
  };
  
  
 const handleFormulaInput = (e) => {
    const inputValue = e.target.value;
    setFormula(inputValue);

    const isFormulaValid = validateFormula(inputValue, numFields);
    setIsValid(isFormulaValid);
  };

  const addDefaultFields = () => {
    setFields((prevFields) => {
      const updatedFields = [...prevFields, ...defaultFields];
      setFormula(''); 
      return updatedFields;
    });
  };

  const removeField = (index) => {
    const fieldToRemove = fields[index];
    if (fieldToRemove.isDefault) {
      alert("This field cannot be removed.");
    } else {
      const updatedFields = fields.filter((_, i) => i !== index);
      setFields(updatedFields);
      setFormula('');   
    }
  };


  const defaultFields = [
    {
      fields: [
        {
          type: "text",
          label: "Title",
          dataName: `title-${Date.now()}`,
          placeholder: "Enter title...",
          value: "", 
          minValue: "", 
          maxValue: "", 
          required: true
        },
        {
          type: "textarea",
          label: "Description",
          dataName: `description-${Date.now()}`,
          placeholder: "Enter description...",
          value: "", 
          required: true
        },
      ],
    },
  ];

  const updateField = (updatedFields) => {
    setFields(updatedFields);
  };
  

  const updateTitleAndDescription = (title, description) => {
    setTitleValue(title);
    setDescriptionValue(description);
  };

 
  const validateFields = () => {
    return fields.every(field => {
      return field.fields.every(subField => {
        if (subField.required) {
          return subField.value.trim() !== ""; 
        }
        return true; 
      });
    });
  };

  
  const handelSubmit =  async(e) =>{
    e.preventDefault();
    if (!validateFields()) {
      toast.error("Please fill in all required fields."); 
      return; 
    }
    if (!isValid && formula.trim() !== "") {
      toast.error("Please enter a valid formula in Overall value");
      return;
    }

     let hasMinMaxErrors = false;
          fields.forEach((field) => {
            if (field.hasOwnProperty("minValue") || field.hasOwnProperty("maxValue")) {
              if (!field.minValue || !field.maxValue) {
                toast.error(`Please Check, both Min and Max values are Required`);
                hasMinMaxErrors = true;
              }
            }
         
            if (field.fields) {
              field.fields.forEach((subField) => {
                if (subField.hasOwnProperty("minValue") || subField.hasOwnProperty("maxValue")) {
                  if (!subField.minValue || !subField.maxValue) {
                    toast.error(`Please Check, both Min and Max values are Required`);
                    hasMinMaxErrors = true;
                  }
                }
              });
            }
          });
         
          if (hasMinMaxErrors) return;
          
  
    const formData = {
      eventId: initialEventId,
      roundId: roundId, 
      form_schema: generatedSchema || fields,
      scorecard_categories: selectedCategoryNames || [],
      categoryId: selectedCategories || [],
    };

    if (formula.trim()) {
      formData.overall_value = formula.trim();
    }
  
    else {
      delete formData.overall_value;
    }
  
  
    try {
      const response = await axios.post(`${EXCHNAGE_URL}/scorecard`, formData,{
        headers: {
          "Content-Type": "application/json",  
          "Authorization": `Bearer ${token}`, 
        },
      });
      toast.success("Scorecard created successfully!");
      setScoreCardValue(response.data.data.scoreFormId)
      console.log(response.data.data.scoreFormId,"999999999999")
      navigate("/jury-round"); 
    } catch (error) {
      console.error(error);
      toast.error(error,"Failed.");
    }
  };

  const token = localStorage.getItem("token")

  const getCategories = async() =>{
    setLoader(true)
     try {
      let apiUrl = `${EXCHNAGE_URL}/allAwards?eventId=${initialEventId}&sortOrder=${sortOrder}`;
      if (searchTerm) {
        apiUrl += `&search=${searchTerm}`;
      }
      const response = await axios.get(apiUrl,{
        headers:{
          "Content-Type":"Application/json",
          authorization: `Bearer ${token}`,
        },
      });
      if(response.status === 200){
        setCategories(response.data.data)
      }
     } catch (error) {
      console.log(error)
     }
  }
  const handleChange = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedId = selectedOption.getAttribute("data-id");
    const selectedName = selectedOption.value;

    if (!selectedId || selectedCategories.includes(Number(selectedId))) return;

    setSelectedCategories((prev) => [...prev, Number(selectedId)]); 
    setSelectedCategoryNames((prev) => [...prev, selectedName]);

    SetFormValues((prevValues) => ({
      ...prevValues,
      [e.target.name]: "",
    }));
  };

  console.log(selectedCategoryNames,"selecteddddd")
  const removeCategory = (idToRemove) => {
    const index = selectedCategories.indexOf(idToRemove);
    if (index !== -1) {
      setSelectedCategories((prev) => prev.filter((id) => id !== idToRemove));
      setSelectedCategoryNames((prev) => prev.filter((_, i) => i !== index));
    }
  };


const handleSaveField = (updatedField) => {
  const updatedFields = fields.map((field) => {
    if (field.fields) {
      return {
        ...field,
        fields: field.fields.map((subField) => {
          if (subField.dataName === updatedField.dataName) {
            return {
              ...subField, 
              ...updatedField,  
            };
          }
          return subField;  
        }),
      };
    }
    return field;  
  });

  setFields(updatedFields); 
  setCurrentField(null); 
};



useEffect(() => {
  setFields([...defaultFields]); 
  getCategories();
}, [initialEventId, searchTerm, sortOrder, scoreCardValue]);

  return (
    <>
    {totalScorecards === 0 ?
  (
    <>
    <div className="create_jury_content_two">
      <div className="create_jury_heading">
        <RedMainHeading>ScoreCard {totalScorecards+1}</RedMainHeading>
      </div>

      <div className="create_jury_select_div">
        <InputLabel> Scorecard criteria </InputLabel>

        
        <div>
    <div className="formappp">
      <div className="canvas-savee">
        <FormCanvas
           fields={fields}
           updateField={updateField}
           removeField={removeField}
           onGenerateSchema={setGeneratedSchema}
           titleValue={titleValue} 
           descriptionValue={descriptionValue} 
           updateTitleAndDescription={updateTitleAndDescription} 
           openModal={openModal}
        />
        <div className="registratation_button">
          <RedBackgroundButton onClick={addDefaultFields}>Add New Fields</RedBackgroundButton>
        </div>
      </div>
    </div>

    {currentField && (
      <EditFieldModal
      fields={fields}
        field={currentField}
        onSave={handleSaveField}  
        onClose={() => setCurrentField(null)}  
      />
    )}
  </div> 
      </div>

      <div className="create_jury_select_div">
        <div className="create_jury_overall">
          <div className="create_juryoverall_head">
            <InputLabel> Overall Scorecard Value </InputLabel>
            <CheckLabel>
              This is the calculated overall Scorecard value of a
              submission
            </CheckLabel>
          </div>
          <InputType type="text" 
           value={formula}
           placeholder={`Enter formula using placeholders {1}, {2}, ...`}
           onChange={handleFormulaInput}
          />
        </div>

           <div 
                    className="tooltip-container"
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    <FaInfoCircle className="info-icon" />
                    
                    <div className={`tooltip ${showTooltip ? 'visible' : ''}`}>
                        By default, the Overall Scorecard Value of a submission is its total score, i.e. the sum of all the scores for each criteria. 
                        However, you can also do averages, e.g. ({1}+{2}+{3})/3 where {1} is the score for criteria 1, {2} is the score for criteria 2, and {3} is the score for criteria 3.
                    </div>
                </div>
             

        <div className="create_jury_overall">
          <InputLabel>
            Use this scorecard for the following Categories
          </InputLabel>
           <SelectBorder 
                          name="category"
                          value={formValues.category}
                          onChange={handleChange}>
                          <option value="">Select a Category</option>
                          {categories.map((category) => (
                            <option
                            key={category.awardId}
                            value={category.category_name}
                            data-id={category.awardId}
                            disabled={categories.includes(category.awardId)}
                          >
                            {category.category_name}
                          </option>
                    ))}
                          </SelectBorder>
                          <div className="selected-categories">
                  {selectedCategories.map((id) => {
                    const category = categories.find((cat) => cat.awardId === id);
                    return (
                      <span key={id} className="category-tag">
                        {category?.category_name}
                        <button
                          type="button"
                          onClick={() => removeCategory(id)}
                          className="remove-btn"
                        >
                          ✕
                        </button>
                      </span>
                    );
                  })}
                </div>
        </div>
      </div>




    </div>

    <div className="create_jury_btndiv">
      <GreyBorderButton>Cancel</GreyBorderButton>
      <RedBackgroundButton
        onClick={handelSubmit}
        >
        Create
      </RedBackgroundButton>
      {/* <GreyBackgroundButton onClick={() => {
        navigate("/jury-round");
      }}
      >Create & Add New
      </GreyBackgroundButton> */}
    </div>

  </>
  ) 
:
(
  <ScoreCardData scoreCardValue={scoreCardValue} totalScorecards={totalScorecards}/>
)
  }
 
    </>
    
    
  )
}

export default CreateScoreCard